module.exports = __webpack_public_path__ + "static/shinbi-do-2a87881b0f8a46705b163311140895c0.mp4";